
import { Button, FormGroup, FormHelperText } from "@mui/material";
import { useEffect, useState } from "react";
import { useGeneralPairing } from "../../providers/GeneralPairing";
import { usePairingList } from "../../providers/PairingListProvider";
import CustomToolbar from "./CustomToolbar/CustomToolbar";
import { inputValidation } from "../../helpers/commonHelpers";
import './PairingListBody.scss';
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { useColumnPresets } from "../../providers/ColumnPresets";
import Loader from "../Loader/Loader";


export default function PairingListBody({
  searchState,
  dataList = [] as any[],
  setMenuAnchorEl,
  setCurrentCategory,
  xGridColumns,
  sortModel,
  setSortModel,
  colVisibility,
  setColVisibility,
  dbmInfo,
  presetDropdownOptions,
}) {
  const totalNum = dataList.reduce((a, b: any) => (a + b?.pairinglist?.length), 0);
  const [showAddInput, setShowAddInput] = useState(false);
  const [addInput, setAddInput] = useState('');
  const pairingContext = useGeneralPairing();
  const pairingListContext = usePairingList();
  const [error, setError] = useState(false);
  const [errorMax, setErrorMax] = useState(false);
  const { t } = useTranslation();
  const columnPresetsContext = useColumnPresets();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!columnPresetsContext.columnPreferences.columns || !colVisibility) {
      return;
    }
    let temp = {};
    columnPresetsContext.columnPreferences.columns.forEach((obj) => {
      temp[obj.internalCode] = obj.preferredDisplay;
    });
    if(columnPresetsContext.columnPreferences.sortOrder) handleSortChange(columnPresetsContext.columnPreferences.sortOrder);
    setColVisibility({ ...temp });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnPresetsContext.columnPreferences.columns]);

  const handleAddNewCategory = async () => {
    if (!addInput) {
      setError(true);
      return;
    }
    await pairingContext.addToCategory(searchState, addInput);
    pairingListContext.getPairingListData(searchState);
  }

  const handleValidation = (e) => {
    if (!inputValidation(e.target.value.trim())) {
      setError(true);
      setErrorMax(false);
    }else if (e.target.value.length >= e.target.maxLength) {
      setErrorMax(true);
      setError(false);
    }else {
      setError(false);
      setErrorMax(false);
    }
  }

  const handleCategoryHeaderClick = (anchor, category) => {
    setMenuAnchorEl(anchor);
    const isTop = dataList.map((f, i) => ({ name: f.categoryName, index: i })).filter(f => f.name === category.categoryName)[0].index === 0;
    const isBottom = dataList.map((f, i) => ({ name: f.categoryName, index: i })).filter(d => d.name === category.categoryName)[0].index === dataList.length - 1;
    setCurrentCategory({
      name: category.categoryName,
      id: category.categoryId,
      isTop,
      isBottom,
      isHeader: true,
      pairingList: category.pairinglist
    });
  }

  let saveSort: boolean = false; 
  const handleSortChange = (model) => {
    setSortModel(model);
    if(saveSort) columnPresetsContext.saveSortPreferenceData(model);
    setLoading(false);
  }

  const handleColumnClick = () => saveSort = true;


  return loading ? <Loader /> : (
    <div className="pairing-list-content">
  <div className='data-grid-table pairing-list-data'>
    <CustomToolbar
      dbmInfo={dbmInfo}
      setShowAddInput={setShowAddInput}
      showAddInput={showAddInput}
      xGridColumns={xGridColumns}
      colVisibility={colVisibility}
      setColVisibility={setColVisibility}
      presetDropdownOptions={presetDropdownOptions}
      totalNum={totalNum}
      searchState={searchState}
      dataList={dataList}
      setLoading={setLoading}
    />
    {<>
      {showAddInput ?
        <FormGroup className="add-category-input-form">
          <div className="input-wrapper">
          <input type="text"
             placeholder="New Category"
             className = { error || errorMax ? 'category-text-input text-error' : 'category-text-input'}
              // aria-describedby="category-name-error"
              onChange={(e) => setAddInput(e.target.value)}
              onKeyUp={(e) => handleValidation(e)} minLength = {0} maxLength = {31}
              // onKeyUp={(e: any) => inputValidation(e.target.value.trim()) ? setError(false) : setError(true)}
            />
            {error || errorMax ? <Button disabled className='diabled-add-category-input-btn'>Done</Button> : <Button onClick={() => handleAddNewCategory()}>Done</Button>}
          </div>
          <FormHelperText className="category-name-error">
            {error ? <><i className='icon-circle-flight' /><span>{t('pairingList.errorCategoryName')}</span></> : ''}
            {errorMax ? <><i className='icon-circle-flight' /><span>{t('editTableColumns.preset-max-error')}</span></>: ''}
            </FormHelperText>
        </FormGroup>
        : ''}
      {dataList.sort((a, b) => a.sortOrder - b.sortOrder).map((data: any, index) => (
        <section key={index}>
          <h4 className="title">
            {data.categoryName}
            <span onClick={(e) => handleCategoryHeaderClick(e.currentTarget, data)} ><i className="icon-action-overflow" /></span>
          </h4>
          <div className='pairing-package-table dbm-report-table'>
            {data && data.pairinglist && data.pairinglist.length > 0 ?
              <DataGridPro
                getRowClassName={(params) => (params.id === 0) ? 'removed' : params.row.isDeleted ? 'pairing-list-row-deleted' : params.row.isModified ? 'pairing-list-row-modified' : ''}
                autoHeight
                disableColumnMenu
                disableRowSelectionOnClick
                columnVisibilityModel={colVisibility}
                //disableSelectionOnClick
                // disableExtendRowFullWidth={false}
                // pageSize={10}
                rows={data.pairinglist}
                getRowId={(r) => r.pairingId}
                columns={xGridColumns}
                sortModel={sortModel}
                onSortModelChange={(model) => handleSortChange(model)}
                onColumnHeaderClick={handleColumnClick}
                hideFooterPagination
              /> :
              <div className='data-grid-table'>
                <div className="no-result-msg"> {t('pairingList.noPairings')}</div>
              </div>}
            <div className='no-of-results'>Total: {data.pairinglist.length} pairings</div>
          </div>
        </section>
      ))
      }
      {totalNum <= 0 && dataList.length <= 0 ? <div className='data-grid-table'>
        <div className="no-result-msg"> {t('pairingList.noPairings')}</div>
      </div> : ""}
    </>}
  </div>
  </div>)
}
